import { z } from "zod";
import { zExt } from "../common/zod-util";

export enum ChatResponder {
  AI = "AI",
  MERCHANT = "MERCHANT",
}
export const chatSchema = z.object({
  responder: z.nativeEnum(ChatResponder),
  message: z.string(),
  createdAt: z.date(),
  teamId: zExt.objectId(),
  returnId: zExt.objectId(),
  _id: zExt.objectId(),
});

export type Chat = z.infer<typeof chatSchema>;
